import { useEffect } from "react";
import { useParams } from "react-router-dom";

/**
 * Hosted fallback booking page — for hotels without their own website.
 * Loads the embeddable widget against the current hotel_id.
 */
export default function BookEmbed() {
    const { hotelId } = useParams();

    useEffect(() => {
        const base = process.env.REACT_APP_BACKEND_URL || window.location.origin;
        const src = `${base}/api/booking-engine/widget.js`;
        let script = document.querySelector(`script[data-akm-host]`);
        if (!script) {
            script = document.createElement("script");
            script.src = src;
            script.async = true;
            script.setAttribute("data-akm-host", "1");
            document.body.appendChild(script);
        }
        const t = setTimeout(() => {
            if (window.Akomoda?.init) window.Akomoda.init();
        }, 400);
        return () => clearTimeout(t);
    }, [hotelId]);

    return (
        <div className="min-h-screen bg-[#F8FAFC]" data-testid="book-embed-page">
            <div className="mx-auto max-w-3xl px-4 py-10">
                <div
                    data-akomoda-booking
                    data-hotel-id={hotelId}
                    data-mode="full"
                />
                <div className="mt-6 text-center text-[11px] text-slate-400">
                    Powered by Akomoda
                </div>
            </div>
        </div>
    );
}
